import { Component } from '@angular/core';
import { ResourceService } from 'sce-core';
import { SimpleEntityDataService } from './../../../shared/services/searchable-entity/simple-entity/simple-entity-data.service';
import { ViewAllPrintJobsButtonService } from './services/view-all-print-jobs-button.service';
import { ViewAllPrintJobsActionService } from './services/view-all-print-jobs-action.service';
import { SimpleEntityBackendService } from '../../../shared/services/searchable-entity/simple-entity/simple-entity-backend.service';
import { SimpleEntityDataEditorService } from '../../../shared/services/searchable-entity/simple-entity/simple-entity-data-editor.service';
import { SearchableEntityServiceFactory } from '../../../shared/services/searchable-entity/searchable-entity-service-factory';
import { SearchableEntityConfig } from '../../../shared/models/searchable-entity-config';

@Component({
  selector: 'lfwms-view-all-print-jobs',
  templateUrl: './view-all-print-jobs-home.component.html',
  styleUrls: ['./view-all-print-jobs-home.component.css'],
  providers: [SimpleEntityDataService,
    ViewAllPrintJobsButtonService,
    ViewAllPrintJobsActionService,
    SimpleEntityBackendService,
    SimpleEntityDataEditorService]
})
export class ViewAllPrintJobsHomeComponent {

  public serviceFactory: SearchableEntityServiceFactory;

  constructor(dataService: SimpleEntityDataService,
      buttonService: ViewAllPrintJobsButtonService,
      actionService: ViewAllPrintJobsActionService,
      backendService: SimpleEntityBackendService,
      dataEditor: SimpleEntityDataEditorService,
      private resourceService: ResourceService) {
    this.serviceFactory = new SearchableEntityServiceFactory(dataService,
      actionService, backendService, dataEditor, buttonService);
    dataService.initializeEntityConfiguration(this.createEntityConfig());
    dataService.initializeSearchContext();
  }

  protected createEntityConfig(): SearchableEntityConfig {
    const entityConfig: SearchableEntityConfig = new SearchableEntityConfig('View Print Jobs');
    entityConfig.setPageTitle(this.resourceService.get('lbl_print_jobs'));
    entityConfig.setItemLabel(this.resourceService.get('lbl_print_jobs'));
    entityConfig.setBreadCrumbPrefix('View Print Jobs');
    entityConfig.initializePrimarySearchForTableId('printjobtd', 'job_id');
    entityConfig.setSearchPageRoute('/home/reports/viewPrintJobs/');
    entityConfig.setUseAdvancedTable(true);
    entityConfig.getPrimarySearchParams().paginateLocally = false;
    entityConfig.getPrimarySearchParams().isFullFetch = true;
    return entityConfig;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/view-all-print-jobs/view-all-print-jobs-home.component.ts